// extracted by mini-css-extract-plugin
export default {"geneUploadIdsPopover":"GeneUploadIds_geneUploadIdsPopover__d2Xuh"};